export default __webpack_public_path__ + "static/media/index.5636ef18.less";